// Add event listener for social share buttons
function socialShareClickListener(e) {
    if (!e.target.matches('.js-social-share-button')) return;

    const url = e.target.dataset.url;
    const windowParams = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0';
    const windowName = 'PinterestWindow';
    e.stopPropagation();
    e.preventDefault();
    window.open(url, windowName, windowParams);
}
document.addEventListener('click', socialShareClickListener, true);
// touchstart was hijacked by simple-lightbox so had to add another event listener
document.addEventListener('touchstart', socialShareClickListener, true);